/**
 * Date Range Filter component for reports
 * Updated to use shadcn/ui Calendar component
 */

import { Label } from '@/components/ui/label'
import { Button } from '@/components/ui/button'
import { Card, CardContent } from '@/components/ui/card'
import { DatePicker } from '@/components/common/DatePicker'

interface DateRangeFilterProps {
  startDate: string
  endDate: string
  onStartDateChange: (date: string) => void
  onEndDateChange: (date: string) => void
  onReset: () => void
}

export function DateRangeFilter({
  startDate,
  endDate,
  onStartDateChange,
  onEndDateChange,
  onReset,
}: DateRangeFilterProps) {
  return (
    <Card className="mb-4 sm:mb-6">
      <CardContent className="pt-4 sm:pt-6">
        <div className="flex flex-col sm:flex-row sm:flex-wrap gap-3 sm:gap-4 sm:items-end">
          <div className="flex-1 w-full sm:min-w-[200px]">
            <Label htmlFor="startDate" className="mb-2">
              Từ ngày
            </Label>
            <DatePicker
              value={startDate}
              onChange={onStartDateChange}
              id="startDate"
              placeholder="Chọn ngày bắt đầu"
            />
          </div>

          <div className="flex-1 w-full sm:min-w-[200px]">
            <Label htmlFor="endDate" className="mb-2">
              Đến ngày
            </Label>
            <DatePicker
              value={endDate}
              onChange={onEndDateChange}
              id="endDate"
              placeholder="Chọn ngày kết thúc"
            />
          </div>

          <div className="w-full sm:w-auto">
            <Button 
              onClick={onReset} 
              variant="outline" 
              type="button"
              className="w-full sm:w-auto min-h-[44px]"
            >
              Đặt lại
            </Button>
          </div>
        </div>
      </CardContent>
    </Card>
  )
}
